import { Box, Card, Flex, Text, Badge } from '@radix-ui/themes';
import React, { useState } from 'react';
import { COMPETENCY_COLORS } from '../../utils/constants';
import { CheckIcon, TrashIcon, ExclamationTriangleIcon } from '@radix-ui/react-icons';

const TeacherCourseList = ({ courses, onCourseSelect, selectedCourse = {} }) => {
  // const [selectedCourse, setSelectedCourse] = selectedCourse;
  console.log('courses::', courses);

  const handleCourseSelect = (course) => {
    // setSelectedCourse(course);
    // console.log('selectedCourse::', selectedCourse);
    onCourseSelect?.(course);
  };

  return (
    <Box>
      <Flex direction="column" gap="2">
        {courses?.map((course) => (
          <Card 
            key={course.id}
            onClick={() => handleCourseSelect(course)}
            style={{ cursor: 'pointer', outline: selectedCourse?.id === course.id ? '2px solid var(--accent-8)' : 'none' }}
            variant={selectedCourse?.id === course.id ? 'solid' : 'soft'}
          >
              <Flex direction="row" justify="between">
                <Text size="2" style={{ color: selectedCourse?.id === course.id ? 'var(--accent-9)' : 'gray' }}>{course.level.label} | {course.subject.label}</Text>
                <Flex direction="row" gap="2" align='center'>
                  {course.active_teaching_plan ? <Badge color="grass"><CheckIcon /></Badge> : <Badge color="pink"><ExclamationTriangleIcon /></Badge>}
                  {course.schedules && course.schedules.length > 0 && <Badge>{course.schedules.length}</Badge>}
                </Flex>
              </Flex>
          </Card>
        ))}
      </Flex>
    </Box>
  );
};

export default TeacherCourseList;
